
import $ from 'jquery';
import { parseTemp } from '../../../common/static/js/common.es6';

// 获取登录后用户的信息
export const userInfo = {
    uid: A.Cookie.getCookie('auth_key'),
    avatar: A.Cookie.getCookie('ac_userimg'),
    name: A.Cookie.getCookie('ac_username'),
    did: A.Cookie.getCookie('_did'),
    checkMobile: A.Cookie.getCookie('checkMobile'),
    onlineTime: 0,
    ban: false,
    getUid() {
        return this.uid;
    },
    getUserName() {
        return this.name;
    },
    getDid() {
        return this.did;
    },
    isCheckMobile() {
        return Boolean(this.checkMobile && this.checkMobile != '-1');
    },
    isLogin() {
        return this.uid > 0;
    },
    getUnRead(callBack) {
        const _this = this;
        $.get('/member/unRead.aspx', {
            uid: _this.uid,
        }).fail(function () {
            return 0;
        }).done(function (data) {
            _this.unread = {
                push: data.newPush | 0,
                at: data.mention | 0,
                mail: data.unReadMail | 0,
                fan: data.newFollowed | 0,
                special: data.special,
                bangumi: data.bangumi,
                setting: data.setting | 0,
            };
            callBack(_this.unread);

        });
    },
    renderUnRead(data) {
        const _this = this;
        let html = '';
        let counts = 0;
        let url = '';
        if (data) {
            const domain = globalConfig && globalConfig.domain ? globalConfig.domain : '';
            const temp = '<li><a class="unit" href="' + domain + '/member/#area=[path]" target="_blank">您有<span class="pts">[pts]</span>[unit]新[type]</a></li>';
            const arr = [
                {
                    type: '推送',
                    path: 'push',
                    pts: _this.unread.push,
                }, {
                    type: '听众',
                    path: 'followers',
                    pts: _this.unread.fan,
                    unit: '个',
                },
                // {
                //     type: '召唤',
                //     path: 'mention',
                //     pts: _this.unread.at,
                // }, {
                //     type: '私信',
                //     path: 'mail',
                //     pts: _this.unread.mail,
                // },
                {
                    type: '剧集推送',
                    path: 'favourite-bangumi',
                    pts: _this.unread.bangumi && _this.unread.bangumi.length,
                }, {
                    type: '合辑推送',
                    path: 'favourite-album',
                    pts: _this.unread.special && _this.unread.special.length,
                }, {
                    type: '设置提醒',
                    path: 'profile',
                    pts: _this.unread.setting,
                },
            ];
            const renderItem = itemData => {
                if (itemData.pts) {
                    html += parseTemp(temp, {
                        type: itemData.type,
                        path: itemData.path || 'splash',
                        icon: itemData.icon || 'play-circle',
                        pts: itemData.pts || 0,
                        unit: itemData.unit || '条',
                    });
                    counts += itemData.pts;
                    url = domain + '/member/#area=' + itemData.path;
                }
            };

            arr.forEach(v => {
                renderItem(v);
            });

            if (counts > 0) {
                if (counts > 99) {
                    counts = '99+';
                }
            } else {
                html = '<li><i class="icon icon-info-circle"></i>暂未有任何推送或未读信息。</li>';
            }
        }

        return '<ul id="user-message-con" data-count="' + counts + '" data-url="' + url + '">' + html + '</ul>';
    },

};
